import RuleRouteName from './RuleRouteName';
import RoutesSsp from './RoutesSsp';
import RouteNames from '../RouteNames';
import SharedRoutesDefinitions from './SharedRoutesDefinitions';

const routes = [
  {
    path: '/administration/:systemId(\\d+)/cmms/rule',
    name: RuleRouteName.RULE,
    component: () => import('../../../administration/pages/cmms/event/RuleOverviewPage.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/cmms/rule/config',
    name: RuleRouteName.RULE_CONFIG,
    component: () => import('../../../administration/pages/cmms/event/RuleConfigPage.vue'),
    props: true,
  },
  {
    path: '/administration/:systemId(\\d+)/cmms/rule/copy',
    name: RuleRouteName.RULE_COPY,
    component: () => import('../../../administration/pages/cmms/event/RuleCopyPage.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/cmms/rule/ticket/',
    name: RuleRouteName.RULE_TICKET,
    component: () => import('../../../administration/pages/cmms/event/RuleTicketPage.vue'),
    props: true,
  },
  {
    path: '/administration/:systemId(\\d+)/cmms/masterData',
    name: 'masterData',
    component: () => import('../../../administration/pages/cmms/masterData/MasterDataPage.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/alarmSettings',
    name: 'alarmSettings',
    component: () => import('../../../administration/pages/viiu/AlarmSettings.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/customAlarmsSettings',
    name: 'customAlarmsSettings',
    component: () => import('../../../administration/pages/viiu/components/userDefinedAlarms/UserDefinedAlarmsSettings.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/notifications',
    name: 'notifications',
    component: () => import('../../../administration/pages/smartAlarms/Notifications.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/muteAndAutoClose',
    name: 'muteAndAutoClose',
    component: () => import('../../../administration/pages/viiu/MuteAndAutoClose.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/monitoring/transferSettings',
    name: 'transferSettings',
    component: () => import('../../../administration/pages/viiu/TransferSettings.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/powerFlow',
    name: 'powerFlow',
    component: () => import('../../../administration/pages/powerFlow/PowerFlowConfiguration.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/termSelection',
    name: 'termSelection',
    component: () => import('../../../administration/pages/termSelection/simpleTerm/TermSelection.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/termSelection/termConfiguration',
    name: 'termConfiguration',
    component: () => import('../../../administration/pages/termSelection/advancedConfiguration/AdvancedTermConfiguration.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/termSelection/termCreation/:termId(\\d+)?',
    name: 'termCreation',
    component: () => import('../../../administration/pages/termSelection/creation/TermCreation.vue'),
    props: true,
  },
  {
    path: '/administration/:systemId(\\d+)/management/solarAccount',
    name: 'solarAccount',
    component: () => import('../../../administration/pages/solarAccount/SolarAccount.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/management/solarAccount/remuneration',
    name: 'solarAccountRemuneration',
    component: () => import('../../../administration/pages/solarAccount/SolarAccount.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/performanceRatio',
    name: RouteNames.PERFORMANCE_RATIO,
    component: () => import('../../../administration/pages/kpi/PerformanceRatio.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/performanceRatio/editor/:configurationId(\\d+)?',
    name: RouteNames.PERFORMANCE_RATIO_EDITOR,
    component: () => import('../../../administration/pages/kpi/PerformanceRatio.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/performanceRatio/missingEnergySource',
    name: RouteNames.PERFORMANCE_RATIO_MISSING_ENERGY_SOURCE,
    component: () => import('../../../administration/pages/kpi/PerformanceRatio.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/performanceRatioChartSettings',
    name: RouteNames.PERFORMANCE_RATIO_CHART_SETTINGS,
    component: () => import('../../../administration/pages/kpi/PerformanceRatioSettings.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/targetPr',
    name: 'targetPr',
    component: () => import('../../../administration/pages/targetPr/TargetPr.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/systemAvailability',
    name: 'systemAvailability',
    component: () => import('../../../administration/pages/kpi/SystemAvailability.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/targetAvailability',
    name: 'targetAvailability',
    component: () => import('../../../administration/pages/targetAvailability/TargetAvailability.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/yieldForecast',
    name: 'yieldForecast',
    component: () => import('../../../administration/pages/yieldForecast/YieldForecast.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/calculated/simulation',
    name: 'simulation',
    component: () => import('../../../administration/pages/simulation/SolarPowerChart.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)/dataSource/inverterStringMonitoring/:dataloggerId(\\d+)',
    name: RouteNames.INVERTER_STRING_MONITORING,
    component: () => import('../../../administration/pages/datalogger/InverterStringMonitoring.vue'),
    props: true,
  },
  {
    ...SharedRoutesDefinitions[RouteNames.DIGITAL_SIGNALS],
    component: () => import('../../../administration/pages/datalogger/DigitalSignals.vue'),
    props: true,
  },
  {
    ...SharedRoutesDefinitions[RouteNames.BATTERY_INVERTER_ASSIGNMENTS],
    component: () => import('../../../administration/pages/datalogger/BatteryInverterAssignment.vue'),
    props: true,
  },
  {
    path: '/administration/:systemId(\\d+)/dataSource/backupConfig',
    name: RouteNames.BACKUP_CONFIG,
    component: () => import('../../../administration/pages/bluelog/BackupConfig.vue'),
  },
  {
    path: `/administration/:systemId(\\d+)/technicalData/${RouteNames.SYSTEM_TECHNICAL_DATA}`,
    name: RouteNames.SYSTEM_TECHNICAL_DATA,
    component: () => import('../../../administration/pages/technicalData/systemData.vue'),
  },
  {
    path: '/administration/:systemId(\\d+)',
    name: RouteNames.START,
  },
  {
    path: '/',
    name: RouteNames.BASE,
  },
  {
    path: '*',
    name: RouteNames.PAGE_NOT_FOUND,
    component: () => import('../../../common/layout/PageNotFound.vue'),
  },
];

export default [...RoutesSsp, ...routes];
